export const QUESTIONS = [
  '睡眠困難，譬如難以入睡、易醒或早醒',
  '感覺緊張或不安',
  '覺得容易苦惱或動怒',
  '感覺憂鬱、心情低落',
  '覺得比不上別人',
  '有自殺的想法'
];